import { Button, Form, Space } from "antd";
import { useEffect } from "react";
import { DatePicker as ZhDatePicker, Dialog as ZhDialog } from "zhihao-ui-react";

import { dateTimeFormat } from "@/utils";

export interface OilOrderConfirmForm {
    actualRefuelingTime: string;
}

export interface OilOrderConfirmDialogProps {
    open: boolean;
    onCancel: () => void;
    onSubmit: (form: OilOrderConfirmForm) => Promise<void>;
}

/** Vue 确认加油弹窗的 React 迁移版。 */
export function OilOrderConfirmDialog({ open, onCancel, onSubmit }: OilOrderConfirmDialogProps) {
    const [form] = Form.useForm<OilOrderConfirmForm>();

    useEffect(() => {
        if (open) form.setFieldValue("actualRefuelingTime", dateTimeFormat(new Date(), "YYYY-MM-DD HH:mm:00"));
    }, [form, open]);

    return (
        <ZhDialog
            open={open}
            title="是否确认加油"
            width={400}
            onCancel={onCancel}
            footer={
                <Space>
                    <Button onClick={onCancel}>取消</Button>
                    <Button type="primary" onClick={() => void form.validateFields().then(values => onSubmit(values))}>
                        确认
                    </Button>
                </Space>
            }
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="实际加油时间"
                    name="actualRefuelingTime"
                    rules={[{ required: true, message: "请选择实际加油时间" }]}
                >
                    <ZhDatePicker
                        aria-label="实际加油时间"
                        className="w-full"
                        format="YYYY-MM-DD HH:mm"
                        placeholder="请选择实际加油时间"
                        type="datetime"
                        valueFormat="YYYY-MM-DD HH:mm:00"
                    />
                </Form.Item>
            </Form>
        </ZhDialog>
    );
}

export default OilOrderConfirmDialog;
